// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__2ztAS","header":"Messages_header__gMfjf"};